import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListPointagePage = withAsyncLoading(async () =>
    import('./ListPointagePage').then((res) => res.ListPointagePage)
);

export { LoadableListPointagePage };
